let freeGiftPrice = 100;
let priceArray= [0,1];
let currentDiscountCodes = [];
var user_cart = null;
let isProcessing = false;
let showConfetti = false;
const shopifyStorefrontApiUrl =
  "https://gamthiaahar-2.myshopify.com/api/2025-01/graphql.json";
const shopifyStorefrontToken = "40d9f70c870c8cbb73d8864d1f39cd2d";
if (window.location.pathname !== "/cart") {
  fetchCart();
}

function fetchCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      user_cart = cart;
      cartx();
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

function bindingEvent() {
  document
    .querySelectorAll(".cartx-drawer-product-quantity-button")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const eventName = button.getAttribute("name");

        if (eventName !== "plus" && eventName !== "minus") return;

        const li = event.target.closest("li");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: parseInt(li.getAttribute("data-quantity")) || 0,
            price: parseInt(li.getAttribute("data-price")) || 0,
            type: li.getAttribute("data-product-type") || "",
          },
        };

        switch (eventName) {
          case "plus":
            cartx(variantObject, "ADD");
            break;
          case "minus":
            cartx(variantObject, "REMOVE");
            break;
        }
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "ADD");
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-remove-from-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "REMOVE");
      });
    });

  document.querySelectorAll(".code-copy-btn").forEach(function (button) {
    button.addEventListener("click", function () {
      const valueToCopy = this.getAttribute("data-code");

      if (valueToCopy) {
        // Copy to clipboard
        const tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = valueToCopy;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        // Show popup message with animation
        const popup = document.createElement("div");
        popup.className = "copy-popup";
        popup.textContent = "Copied successfully!";
        document.body.appendChild(popup);

        popup.style.position = "fixed";
        popup.style.bottom = "-50px";
        popup.style.left = "50%";
        popup.style.transform = "translateX(-50%)";
        popup.style.opacity = 0;
        popup.style.transition = "all 0.3s ease";

        // Force reflow to apply transition
        void popup.offsetHeight;

        // Animate in
        popup.style.bottom = "70px";
        popup.style.opacity = 1;
        setTimeout(function () {
          popup.style.transition = "all 0.3s ease";
          popup.style.bottom = "0px";
          popup.style.opacity = "0";

          setTimeout(function () {
            popup.remove();
          }, 300);
        }, 1000);
      }
    });
  });

  document.querySelectorAll(".cartx-empty-upsell").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const variantId = button.getAttribute("data-variant-id");
      if (!variantId) return;

      const variantObject = {
        [variantId]: {
          quantity: parseInt(button.getAttribute("data-quantity")) || 0,
          price: parseInt(button.getAttribute("data-price")) || 0,
          type: button.getAttribute("data-product-type") || "",
        },
      };

      cartx(variantObject, "ADD");
    });
  });

  document.querySelectorAll(".prv-submit-button").forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.closest(".prv-coupon-input-container").querySelector(
        ".prv-coupon-input"
      );
      applyCode(input);
    });
  });

  document.querySelectorAll(".prv-coupon-input").forEach((input) => {
    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        applyCode(input);
      }
    });
  });

  if (document.getElementById("cartx-remove-btn") !== null) {
    document
      .getElementById("cartx-remove-btn")
      .addEventListener("click", function () {
        const code = this.getAttribute("data-discount-code");

        removeDiscount(user_cart?.token, code);
      });
  }

  const slider = document.getElementById("cartx-claim-product-list");
  const progress = document.getElementById("scrollProgress");

  if (slider && progress) {
    slider.addEventListener("scroll", () => {
      const scrollLeft = slider.scrollLeft;
      const scrollWidth = slider.scrollWidth - slider.clientWidth;
      const scrolledPercent = (scrollLeft / scrollWidth) * 100;
      progress.style.width = `${scrolledPercent}%`;
    });
  }

  document
    .querySelectorAll(".cartx-variant-cart")
    .forEach(function (selector) {
      
      selector.addEventListener("change", function (event) {
        const selectedOption = event.target.selectedOptions[0];
        const selectedVariantId = selectedOption.value;
        const variantPrice = selectedOption.getAttribute("data-price");
        const quantity = selectedOption.getAttribute("data-quantity");
        const type = selectedOption.getAttribute("data-product-type");
        const finalPrice = selectedOption.getAttribute("data-final-price");

        const li = event.target.closest("li");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [selectedVariantId]: {
            quantity: Number(quantity),
            replace_variant: variantId,
            price: variantPrice,
            type:type,
            final_price:finalPrice
          },
        };

        cartx(variantObject, "ADD");
      });
    });

    document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);
    
      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

  const viewAllBtn = document.querySelector(".prv-view-all");
  const closeBtn = document.querySelector(".cartx-offer-close");
  const offerPanel = document.querySelector(".cartx-all-offers");

  if (viewAllBtn && offerPanel) {
    viewAllBtn.addEventListener("click", function () {
      offerPanel.classList.add("is--visible");
    });
  }

  if (closeBtn && offerPanel) {
    closeBtn.addEventListener("click", function () {
      offerPanel.classList.remove("is--visible");
    });
  }

  const signinBtn = document.getElementById("cartx-signin-btn");
  if (signinBtn) {
    signinBtn.addEventListener("click", function (event) {
      event.preventDefault();
      window.location.href = "/account";
    });
  }

  const applyButtons = document.querySelectorAll(".cartx-apply-button-wrapper");
  if (applyButtons.length > 0) {
    applyButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        applyDiscount(user_cart?.token, couponCode);
      });
    });
  }

  const removeButtons = document.querySelectorAll(
    ".cartx-remove-button-wrapper"
  );
  if (removeButtons.length > 0) {
    removeButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        removeDiscount(user_cart?.token, couponCode);
      });
    });
  }

  initPincodeInput();
  
  loadedEvents();
}

function handleVariantChange(event) {
  
  const selectedOption = event.target.selectedOptions[0];
  const selectedVariantId = selectedOption.value;
  const variantPrice = selectedOption.getAttribute("data-price");
  const type = selectedOption.getAttribute("data-product-type");
  const image = selectedOption.getAttribute("data-image");

  const li = event.target.closest(".cartx-upsell-product-item").querySelector('.cartx-product-button-wrap');
  if (!li) return;

  const formattedPrice = `₹ ${(parseInt(variantPrice) / 100).toFixed(2)}`;

  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-img').src = image;
  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-price .current-price').innerHTML = formattedPrice;
  li.setAttribute("data-variant-id", selectedVariantId);
  li.setAttribute("data-price", variantPrice);
  li.setAttribute("data-product-type", type);
}


function isValidIndianPincodeCart(pincode) {
  var pincodeInput = document.getElementById("pincode_input_cart");
  var expectedCart = document.querySelector(".cartx-drawer .expected_cart");
  pincodeInput.style.color = "#f00";
  expectedCart.textContent = "Enter a valid pincode";
  expectedCart.style.color = "#f00";
  // pincodeInput.style.borderColor = "#f00";
  document.querySelector(".cartx-verified-cart-svg").classList.remove('show-svg');
  // document.getElementById("verified_cart").style.display = "none";
  var regex = /^[1-9][0-9]{5}$/;
  return regex.test(pincode);
}

function getFormattedDate(date) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-IN", options);
}

function handlePincodeInputChangeCart() {
  var pincode = document.getElementById("pincode_input_cart").value;
  if (isValidIndianPincodeCart(pincode)) {
    localStorage.setItem("validPin", pincode);
    document.getElementById("pincode_input_cart").style.color = "green";
    // document.getElementById("pincode_input_cart").style.borderColor = "black";
    // document.getElementById("verified_cart").style.display = "block";

    var url = "https://neworder.plumgoodness.com/get-estimate-date";
    var data = JSON.stringify({ drop_pincode: pincode });

    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var result = JSON.parse(xhr.responseText);
        var expectedCart = document.querySelector(".cartx-drawer .expected_cart");

        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + parseInt(result.expects_max_date));
        // Adding 12 hours to the current time
        currentDate.setHours(currentDate.getHours());
        currentDate.setDate(currentDate.getDate() + 1);

        const formattedDate = getFormattedDate(currentDate);
        expectedCart.innerHTML = `Estimated Delivery Date <br> ${formattedDate}`;
        expectedCart.style.color = "green";
        document.querySelector(".cartx-verified-cart-svg").classList.add('show-svg');
      }
    };
    xhr.send(data);
  }
}

function getFormattedDate(date) {
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const weekday = date.toLocaleString('default', { weekday: 'long' });

  return `${day}${this.getDaySuffix(day)} ${month}, ${weekday}`;
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
      return 'th';
  }
  switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
  }
}

function initPincodeInput() {
  const inputField = document.getElementById("pincode_input_cart");
  if (!inputField) return;

  const storedPin = localStorage.getItem("validPin");
  if (storedPin) {
    inputField.value = storedPin;
    handlePincodeInputChangeCart(); // run immediately
  }

  inputField.addEventListener("keyup", handlePincodeInputChangeCart);
}

function startLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.add("loading");
  }
}

function stopLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.remove("loading");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // const recommendationsEl = document.querySelector("product-recommendations");

  // if (recommendationsEl) {
  //   const observer = new MutationObserver(() => {
  //     if (
  //       recommendationsEl.classList.contains("product-recommendations--loaded")
  //     ) {
  //       loadedEvents();

  //       observer.disconnect(); // stop observing once it's loaded
  //     }
  //   });

  //   observer.observe(recommendationsEl, { attributes: true });
  // }

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains("cartx-product-button-wrap")) {

          loadedEvents();
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  
  loadedEvents();
});

function handleAddToCartClick(event) {
  const button = event.currentTarget;
    
  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  wrapper.classList.add("cartx-button-loadding");

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "ADD");
}

function showViewCart() {
  const viewCart = document.querySelector(".view-cart");
  if (viewCart) {
    viewCart.classList.add("is-visible");
    setTimeout(() => {
      viewCart.classList.remove("is-visible");
    }, 5000);
  }
}

function handleRemoveFromCartClick(event) {
  const button = event.currentTarget;

  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  wrapper.classList.add("cartx-button-loadding");

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "REMOVE");
}

function loadedEvents() {
    
    
    

    
  
  document
    .querySelectorAll(".cartx-add-to-cart:not(.plus)")
    .forEach((button) => {
      
      button.removeEventListener("click", handleAddToCartClick);
      button.addEventListener("click", handleAddToCartClick);
    });

  document.querySelectorAll(".cartx-add-to-cart.plus").forEach((button) => {
    
    button.removeEventListener("click", handleAddToCartClick);
    button.addEventListener("click", handleAddToCartClick);
  });

  document
    .querySelectorAll(".cartx-remove-from-cart.minus")
    .forEach((button) => {
      
      button.removeEventListener("click", handleRemoveFromCartClick);
      button.addEventListener("click", handleRemoveFromCartClick);
    });

    document
    .querySelectorAll(".cartx-icon")
    .forEach((button) => {
      
      button.removeEventListener("click", openDrawer);
      button.addEventListener("click", openDrawer);
    });

    document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);
    
      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

    document.querySelectorAll('.cartx-variant-switcher').forEach(function (selector) {
      selector.removeEventListener("click", handleVariantChangeQuantity);
      selector.addEventListener("click", handleVariantChangeQuantity);
    })


}

function handleVariantChangeQuantity(event) {
  
  
  const variantId = event.target.getAttribute("data-variant-id");
  const productId = event.target.getAttribute("data-product-id");
  const price = event.target.getAttribute("data-variant-price");
  

  document.querySelectorAll('.cartx-product-button-wrap[data-product-id="' + productId + '"]').forEach(function (selector) {
    selector.setAttribute("data-variant-id", variantId);
    selector.setAttribute("data-price", price);
    
  });

  let quantity = 0;

  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == variantId);
    quantity = cartItem ? cartItem.quantity : 0;
  }

  updateQuantity({ [variantId]: { quantity } }, 'CHANGE');
}

function openDrawer(event) {
  event.preventDefault();
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.add("drawer-open");
    overlay.classList.add("open-overlay");
  }
  document.body.classList.add("cartx-open");
}

function closeDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.remove("drawer-open");
    overlay.classList.remove("open-overlay");
  }

  document.body.classList.remove("cartx-open");
}

function cartx(variantObject = {}, event) {
  if (isProcessing) {
    updateQuantity(variantObject, null);
    return;
  }

  isProcessing = true;
  startLoader();

  const allProducts = {};

  const filteredObjects = JSON.parse(document.body.getAttribute("metaobject"));
  const cartFreebie = cleanData(
    JSON.parse(document.body.getAttribute("cartfreebie"))
  );

  let claimGift = JSON.parse(document.body.getAttribute("claimgift"));

//   let scheduledFreebie = JSON.parse(document.body.getAttribute("data-scheduled-freebie"));
//   let startingDate = document.body.getAttribute("data-starting-date");
//   let endingDate = document.body.getAttribute("data-ending-date");

  let activeScheduleGwp = JSON.parse(document.querySelector(".cartx-drawer .cartx-schedule-gwp-wrapper")?.getAttribute("data-schedule-gwp") || "[]");

  let localStorageClaimGift = JSON.parse(
    localStorage.getItem("claimedGiftProducts")
  );

  const cartUpdatedObject = {};
  let totalFreeProduct = 0;
  let totalFreeProductPrice = 0;
  let totalCombosQuantity = 0;
  let totalCombosPrice = 0;

  let isClaimedGift = false;

  user_cart?.items.forEach(
    ({
      id,
      quantity,
      final_line_price,
      original_line_price,
      product_type,
      properties,
    }) => {
      const productId = id.toString();
      

      allProducts[productId] = Number(allProducts[productId] || 0) + quantity;

      if (!cartUpdatedObject[productId])
        cartUpdatedObject[productId] = quantity;

      if (
        (final_line_price === freeGiftPrice && original_line_price === freeGiftPrice) ||
        (final_line_price === 0 && original_line_price === 0)
      ) {
        totalFreeProduct++;
        totalFreeProductPrice += final_line_price;
        if (properties?.claimed_gift !== "true") {
          cartUpdatedObject[productId] = 0;
        }
      }

      if (product_type === "Combos") {
        totalCombosQuantity += quantity;
        totalCombosPrice += final_line_price;
      }
    }
  );

  const cartTotalProductWithoutFreebie =
    user_cart?.item_count - totalFreeProduct - totalCombosQuantity;
  const cartTotalPriceWithoutFreebie =
    user_cart?.total_price - totalFreeProductPrice - totalCombosPrice;

  let totalQuantity = 0;
  let totalPrice = 0;

  let claimedGiftProducts = {};

  

  Object.entries(variantObject).forEach(([key, variant]) => {
    if (variant?.replace_variant) {

      const replaceId = variant.replace_variant;

      // Find the quantity & price of the current cart item being replaced
      const matchedItems = user_cart?.items.filter(
        (item) => item.id.toString() === replaceId
      );


      const itemWithSpecificPrice = matchedItems?.find(
        (item) => Number(item.final_price) === Number(variant?.final_price)
      );


      if (itemWithSpecificPrice) {
        const oldQty = itemWithSpecificPrice.quantity;
        const oldPrice = itemWithSpecificPrice.final_line_price;

        // Reduce totals to offset the old variant being removed
        totalQuantity -= oldQty;
        totalPrice -= oldPrice;

        // Mark the old variant for removal
        cartUpdatedObject[replaceId] = 0;
      }

    }

    if (variant?.type !== "Combos" && variant?.claimed_gift !== "true") {
      totalQuantity += variant?.quantity;
      totalPrice += variant?.price * variant?.quantity;
    }

    if (variant?.claimed_gift === "true") {
      isClaimedGift = true;
      claimedGiftProducts[key] = variant?.quantity; // ✅ only push the key
    }
  });
  

  if (Object.entries(claimedGiftProducts)?.length > 0) {
    localStorage.setItem(
      "claimedGiftProducts",
      JSON.stringify(claimedGiftProducts)
    );
    localStorageClaimGift = claimedGiftProducts;
  }

  const adjustedCartQuantity =
    cartTotalProductWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalQuantity
      : event === "REMOVE"
      ? -totalQuantity
      : 0);

  const adjustedCartPrice =
    cartTotalPriceWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE"
      ? -totalPrice
      : 0);

  const discountPriceCheck =
    user_cart?.total_price +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE"
      ? -totalPrice
      : 0);

  // Find applicable rule
  const applicableRule = getApplicableRule(
    filteredObjects,
    adjustedCartQuantity,
    adjustedCartPrice
  );

  if (applicableRule?.get_y?.length) {
    applicableRule.get_y.forEach((variant) => {
      cartUpdatedObject[variant.split("/").pop()] = 1;
    });
  }

  //Claim Gift Logic
  // Check if the gift is claimed
  if (!isClaimedGift) {
    const applicableRuleClaimGift = getApplicableRule(
      claimGift,
      adjustedCartQuantity,
      adjustedCartPrice
    );

    if (applicableRuleClaimGift) {
      if (applicableRuleClaimGift?.gift_products?.length) {
        if (localStorageClaimGift) {
          applicableRuleClaimGift.gift_products.forEach((variant) => {
            var variantId = variant.split("/").pop();
            if (localStorageClaimGift.hasOwnProperty(variantId)) {
              cartUpdatedObject[variantId] = localStorageClaimGift[variantId];
            }
          });
        }
      }
    } else {
      localStorage.removeItem("claimedGiftProducts");
    }
  }

  // Update cart quantities based on event
  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const currentQty = cartUpdatedObject[productId] || 0;
    const currentQuantiyAll = allProducts[productId] || 0;
    cartUpdatedObject[productId] =
      event === "ADD"
        ? currentQty + quantity
        : event === "MULTI_ADD"
        ? 1
        : Math.max(0, currentQty - quantity);

        allProducts[productId] =
        event === "ADD"
          ? currentQuantiyAll + quantity
          : event === "MULTI_ADD"
          ? 1
          : Math.max(0, currentQuantiyAll - quantity);
  });

  // Apply freebie rules
  cartFreebie?.forEach(({ freebie, products }) => {
    if (freebie.length > 0) {
      products.forEach((productId) => {
        if (
          cartUpdatedObject[productId] &&
          cartUpdatedObject[productId] !== 0
        ) {
          cartUpdatedObject[freebie[0]] = 1;
        }
      });
    }
  });

  
  // if(checkExceedLimit(allProducts, 4)){
  //   showExceedingMessage("You can only add up to 4 of the same item");
  //   updateQuantity(variantObject, null);
  //   stopLoader();
  //   isProcessing = false;
  //   return;
  // }

  if(activeScheduleGwp){

    const applicableRuleScheduleGwp = getApplicableRule(
      activeScheduleGwp,
      adjustedCartQuantity,
      adjustedCartPrice
    );

    if (applicableRuleScheduleGwp?.get_y?.length) {
        applicableRuleScheduleGwp.get_y.forEach((variant) => {
          cartUpdatedObject[variant.split("/").pop()] = 1;
        });
      }
  }

  



  const finalPayload = { updates: cartUpdatedObject };

  if (Object.keys(cartUpdatedObject).length > 0) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        cache: "no-store",
        priority: "high",
        keepalive: true,
      },
      body: JSON.stringify(finalPayload),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`devx-cartx HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        user_cart = data;
        isProcessing = false;

        if(event === "ADD"){
          showViewCart();
        }

        if (
          data?.total_price !== discountPriceCheck &&
          data?.total_price !== 0
        ) {
          cartx();
          updateQuantity(variantObject, event);
        } else {
          reload_cartx(); // Now safely called after update completes
          updateQuantity(variantObject, event);
          updateBubble(user_cart?.item_count);
          // currentDiscountCodes =  user_cart?.attributes?.appliedDiscount.split(',') || [];
          checkDiscountCode(user_cart);
        }
      })
      .catch((error) => {
        console.error("devx-cartx Error updating cart:", error);
        stopLoader();
        isProcessing = false;
      })
      .finally(() => {});
  } else {
    bindingEvent();
    stopLoader();
    checkDiscountCode(user_cart);
    isProcessing = false;
    // currentDiscountCodes =  user_cart?.attributes?.appliedDiscount.split(',') || [];
  }
}

function checkExceedLimit(object, limit) {
  return Object.values(object).some(value => value > limit);
}

// Function to clean the cartFreebie data
function cleanData(cartFreebie) {
  return cartFreebie?.map((item) => ({
    freebie: item.freebie.map((id) =>
      id.replace("gid://shopify/ProductVariant/", "")
    ),
    products: item.products.map((id) =>
      id.replace("gid://shopify/ProductVariant/", "")
    ),
  }));
}

function getApplicableRule(
  filteredObjects,
  adjustedCartQuantity,
  adjustedCartPrice
) {
  if (!filteredObjects || !filteredObjects.length) return null;

  const applicableRules = filteredObjects.filter(
    ({ triggered_quantity, trigger_price }) => {
      if (triggered_quantity !== undefined) {
        return adjustedCartQuantity >= triggered_quantity;
      } else if (trigger_price !== undefined) {
        return adjustedCartPrice >= trigger_price * 100;
      }
      return false;
    }
  );

  const sortedRules = applicableRules.sort((a, b) => {
    const aVal =
      a.triggered_quantity !== undefined
        ? a.triggered_quantity
        : a.trigger_price !== undefined
        ? a.trigger_price * 100
        : 0;

    const bVal =
      b.triggered_quantity !== undefined
        ? b.triggered_quantity
        : b.trigger_price !== undefined
        ? b.trigger_price * 100
        : 0;

    return bVal - aVal; // descending
  });

  return sortedRules[0] || null;
}

function reload_cartx(cart_visible = false, event = null) {
  const sectionId = "cartx-drawer";

  const currentInner = document.querySelector(
    `#shopify-section-${sectionId} .cartx-drawer-inner`
  );

  const oldBottomCart = document.querySelector(
    `#shopify-section-${sectionId} #cartx-bottom-cart`
  );
  currentInner?.classList.add("is-loading");
  let cartScrollPosition = document.querySelector('.cartx-drawer-body-wrap').scrollTop;

  fetch(window.location.pathname + `?sections=${sectionId}`, {
    cache: "no-store",
    priority: "high",
    keepalive: true,
  })
    .then((res) => res.json())
    .then((data) => {
      const updated_cart_html = data[sectionId];

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(updated_cart_html, "text/html");
      const newCartInner = htmlDoc.querySelector(".cartx-drawer-inner");
      const bottomCart = htmlDoc.getElementById("cartx-bottom-cart");

      if (newCartInner && currentInner) {
        currentInner.innerHTML = newCartInner.innerHTML;
        document.querySelector('.cartx-drawer-body-wrap').scrollTop = cartScrollPosition;
        if(showConfetti){
          cartConfetti();
        }
        showConfetti = false;

        if (user_cart?.item_count > 0) {
          updateAiUpsell(user_cart?.items);
        }
        bindingEvent();
        
      }
      if (oldBottomCart && bottomCart) {
        oldBottomCart.innerHTML = bottomCart.innerHTML;
        if (user_cart?.item_count > 0) {
          oldBottomCart.classList.add("show-slide");
        } else {
          oldBottomCart.classList.remove("show-slide");
        }
      }
    })
    .catch((error) => {
      console.error("Error reloading cart:", error);
    })
    .finally(() => {
      currentInner?.classList.remove("is-loading");
      stopLoader();
    });
}

function updateQuantity(variantObject = {}, event) {
  if (!variantObject) return;

  Object.entries(variantObject).forEach(([productId, variant]) => {
    const quantityElements = document.querySelectorAll(
      '.cartx-atc-qty[data-variant-id="' + productId + '"]'
    );

    const quantityElementsWrapper = document.querySelectorAll(
      '.cartx-product-button-wrap[data-variant-id="' + productId + '"]'
    );

    // If this is a replacement variant, also update the old variant's quantity to 0
    if (variant.replace_variant) {
      const oldVariantWrappers = document.querySelectorAll(
        '.cartx-product-button-wrap[data-variant-id="' + variant.replace_variant + '"]'
      );
      
      oldVariantWrappers?.forEach((element) => {
        const el = element.querySelector(".cartx-atc-qty");
        if (el) {
          el.value = 0;
          el.setAttribute('value', 0);
          
          const addToCart = element.querySelector(".cartx-add-to-cart");
          const plusMinusWrapper = element.querySelector(".cartx-add-to-cart-qty-wrap");
          
          addToCart.style.display = "flex";
          plusMinusWrapper.style.display = "none";
        }
      });
    }

    quantityElementsWrapper?.forEach((element) => {
      const el = element.querySelector(".cartx-atc-qty");

      if (el) {
        const addToCart = element.querySelector(".cartx-add-to-cart");
        const plusMinusWrapper = element.querySelector(".cartx-add-to-cart-qty-wrap");

        if (event) {
          if(event == 'CHANGE'){
            el.value = Number(variant.quantity);
            el.setAttribute('value', el.value);
          }
          else{
            el.value =
            Number(el?.value) +
            (event === "ADD" || event == "MULTI_ADD" ? 1 : -1) * Number(variant.quantity);
            el.setAttribute('value', el.value);
          }
        } 

        if (Number(el.value) > 0) {
          addToCart.style.display = "none";
          plusMinusWrapper.style.display = "flex";
        } else {
          addToCart.style.display = "flex";
          plusMinusWrapper.style.display = "none";
        }
      }

      // Always remove loading state, even if event is not found
      if (element.classList.contains("cartx-button-loadding")) {
        element.classList.remove("cartx-button-loadding");
      }
    });
  });
}


function updateBubble(cartCount) {
  const bubbleElements = document.querySelectorAll(".cart-count-bubble");

  const bubbleEle = document.getElementById("cart-icon-bubble");

  bubbleElements.forEach((bubble) => {
    bubbleCount(bubble, cartCount);
  });

  bubbleCount(bubbleEle, cartCount);
}

function bubbleCount(bubble, cartCount) {
  const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
  const hiddenCount = bubble.querySelector(".visually-hidden");

  if (visibleCount) visibleCount.textContent = cartCount;
  if (hiddenCount) hiddenCount.textContent = `${cartCount} items`;
}

function applyCode(codeInput = null) {
  const code = (
    codeInput || document.querySelector(".prv-coupon-input")
  ).value.trim();

  applyDiscount(user_cart?.token, code);
}

// Validate discount code format
function validateDiscountCode(code) {
  // Basic validation - adjust pattern as needed
  return code.replace(/[^\w\-]/g, "");
}

async function applyDiscount(cartId, discountCode) {
  if (!discountCode) {
    showMessage("Please enter a discount code.", true);
    return;
  }

  if (typeof user_cart === "undefined" || user_cart?.item_count === 0) {
    showMessage("Your cart is empty. Add items before applying a code.", true);
    return;
  }

  const sanitizedCode = validateDiscountCode(discountCode);
  if (!sanitizedCode) {
    showMessage("Invalid discount code format.", true);
    return;
  }

  const upperCaseCode = sanitizedCode.toUpperCase();

  if (currentDiscountCodes.includes(upperCaseCode)) {
    showMessage(`Discount code "${sanitizedCode}" is already applied.`, true);
    return;
  }
  startLoader();
  const updatedDiscountCodes = [...currentDiscountCodes, upperCaseCode];

  const query = `
    mutation {
      cartDiscountCodesUpdate(cartId: "gid://shopify/Cart/${cartId}", discountCodes: ${JSON.stringify(
    updatedDiscountCodes
  )}) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(shopifyStorefrontApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": shopifyStorefrontToken,
      },
      body: JSON.stringify({ query }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      stopLoader();
      throw new Error(`API responded with status ${response.status}`);
    }

    const data = await response.json();

    if (data.errors) {
      const firstError = data.errors[0];
      const message =
        firstError.extensions?.code === "UNAUTHORIZED"
          ? "Session expired. Please refresh the page and try again."
          : `Error: ${firstError.message}`;
      showMessage(message, true);
      stopLoader();

      return;
    }

    const discountInfo = data.data?.cartDiscountCodesUpdate;

    if (discountInfo?.userErrors?.length) {
      showMessage(discountInfo.userErrors[0].message, true);
      stopLoader();
    } else {
      const allDiscounts = discountInfo.cart.discountCodes;
      const applicableDiscounts = allDiscounts.filter((d) => d.applicable);
      const newCodeStatus = allDiscounts.find(
        (d) => d.code.toUpperCase() === sanitizedCode.toUpperCase()
      );

      if (newCodeStatus?.applicable) {
        fetchCart();
        showConfetti = true;
      } else {
        showMessage(
          `Discount code "${sanitizedCode}" is not applicable to your cart.`,
          true
        );
        stopLoader();
      }
    }
  } catch (error) {
    stopLoader();
    console.error("Error applying discount:", error);
    const message =
      error.name === "AbortError"
        ? "Request timed out. Please try again."
        : error.message.includes("NetworkError")
        ? "Network error. Please check your connection and try again."
        : "Error applying discount. Please try again later.";
    showMessage(message, true);
  }
}

async function removeDiscount(cartId, discountCode) {
  startLoader();

  let removeDiscount = [
    ...currentDiscountCodes?.filter(
      (item) => item.toUpperCase() !== discountCode.toUpperCase()
    ),
  ];

  const query = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    cartId: `gid://shopify/Cart/${cartId}`,
    discountCodes: removeDiscount,
  };

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(shopifyStorefrontApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": shopifyStorefrontToken,
      },
      body: JSON.stringify({ query, variables }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      stopLoader();
      throw new Error(`API responded with status ${response.status}`);
    }

    const data = await response.json();

    if (data.errors) {
      const firstError = data.errors[0];
      const message =
        firstError.extensions?.code === "UNAUTHORIZED"
          ? "Session expired. Please refresh the page and try again."
          : `Error: ${firstError.message}`;
      showMessage(message, true);
      stopLoader();

      return;
    }

    const discountInfo = data.data?.cartDiscountCodesUpdate;

    if (discountInfo?.userErrors?.length) {
      showMessage(discountInfo.userErrors[0].message, true);
      stopLoader();
    } else {
      const allDiscounts = discountInfo.cart.discountCodes;
      const applicableDiscounts = allDiscounts.filter((d) => d.applicable);

      currentDiscountCodes = applicableDiscounts.map((d) =>
        d.code.toUpperCase()
      );

      cartx();
    }
  } catch (error) {
    stopLoader();
    console.error("Error applying discount:", error);
    const message =
      error.name === "AbortError"
        ? "Request timed out. Please try again."
        : error.message.includes("NetworkError")
        ? "Network error. Please check your connection and try again."
        : "Error applying discount. Please try again later.";
    showMessage(message, true);
  }
}

function checkDiscountCode(cart) {
  const uniqueDiscountCodes = new Set();
  cart?.items.forEach((item) => {
    item.line_level_discount_allocations
      .filter((item) => item.discount_application.type === "discount_code")
      .forEach((item) =>
        uniqueDiscountCodes.add(item.discount_application.title)
      );
  });
  cart?.cart_level_discount_applications
    .filter((item) => item?.discount_application?.type === "discount_code")
    .forEach((item) =>
      uniqueDiscountCodes.add(item?.discount_application?.title)
    );

  currentDiscountCodes = [...uniqueDiscountCodes].map((code) =>
    code.toUpperCase()
  );
  
}

function showMessage(message, isError = false) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add(isError ? "red-message" : "green-message");
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove(isError ? "red-message" : "green-message");
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 3000);
}

function showExceedingMessage(message) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add('purple-message');
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove('purple-message');
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 2000);
}


function updateAiUpsell(variants) {
  const myHeaders = new Headers();
  myHeaders.append(
    "Authorization",
    "Bearer bISSXPxCSDaD2el8UoOuX6wAm6qMvb0h43jD2ptW"
  );

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const productGIDs = encodeURIComponent(
    JSON.stringify(
      variants?.map((product) => `gid://shopify/Product/${product.product_id}`)
    )
  );

  const upsellWrap = document.querySelector(".cartx-ai-upsell");

  fetch(
    `https://gn30lesfub.execute-api.ap-south-1.amazonaws.com/prod/0f59a0b7-ae46-45b7-a79b-a8b41d4aa0c4/datasource/94b12791-adea-4d5d-8a87-60adc7a062f5/upsell?ids=${productGIDs}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      const container = document.getElementById("cartx-upsell-product-list");
      
      
      if (data && data?.products?.length > 0 && Array.isArray(data?.products)) {
        data.products.forEach((product, index) => {
          if (upsellWrap) upsellWrap.style.display = "block";


          

          const variant = product?.variants?.edges?.[0]?.node;
          const image = product?.variants?.edges?.[0]?.node?.image?.url || "";
          const title = product?.title || "Untitled";
          const productType = product?.productType || "";
          const productUrl =
            "/products/" + product?.handle || "javascript:void(0);";

            const variants = product?.variants?.edges || [];
            const selectedVariantId = product?.selectedVariant?.id?.replace("gid://shopify/ProductVariant/", "");
            let variantOptionsHTML = "";
            
            if (variants.length > 1) {
              variantOptionsHTML = `
                <div class="cartx-variant-selector-wrapper">
                  <select class="cartx-variant-dropdown-main cartx-variant-upsell">
                    ${variants
                      .map(({ node }) => {
                        const variantId = node.id.replace("gid://shopify/ProductVariant/", "");
                        const price = (node.price.amount)*100;
                        const title = node.title;
                        const quantity = node.inventoryQuantity || 1; // fallback if not available
                        const selectedAttr = variantId === selectedVariantId ? "selected" : "";
                        const image = node.image?.url || "";
            
                        return `
                          <option 
                            data-quantity="1" 
                            data-image="${image}"
                            data-price="${price}" 
                            data-product-type="${productType}"
                            value="${variantId}" 
                            ${selectedAttr}
                          >
                            ${title}
                          </option>`;
                      })
                      .join("")}
                  </select>
                </div>`;
            }
            
            

          const price = variant.price.amount ? variant.price.amount / 1 : "0";
          const compareAtPrice = variant.compareAtPrice?.amount
            ? variant.compareAtPrice.amount / 1
            : "";

          const upsellDiv = document.createElement("div");
          upsellDiv.className = "cartx-upsell-product-item";
          upsellDiv.setAttribute(
            "data_prod_id",
            variant.id.replace("gid://shopify/ProductVariant/", "")
          );

          upsellDiv.innerHTML = `
  <div class="cartx-upsell-item-media">
    <img class="cartx-upsell-item-img" width="74" height="74" src="${image}&width=174" alt="${title}">
  </div>
  <div class="cartx-upsell-item-info">
    <a href=${productUrl} class="cartx-upsell-item-title">${title}</a>
    <div class="cartx-upsell-item-price-wrap">
      <div class="cartx-upsell-item-price">
        <span class="current-price">₹ ${price}.00</span>
        ${compareAtPrice ? `<span class="cartx-compare-price">₹ ${compareAtPrice}.00</span>` : ''}
      </div>
      ${compareAtPrice > price ? `
        <div class="cartx-percentage-off">
                  ${Math.round(((compareAtPrice - price) / compareAtPrice) * 100)}% OFF
                  </div>
          ` : ''}
    </div>

    ${!priceArray.includes(price) ? `
      <div
        class="cartx-product-button-wrap"
        data-variant-id="${variant.id.replace(
          "gid://shopify/ProductVariant/",
          ""
        )}"
        data-quantity="1"
        data-price="${variant.price.amount * 100}"
        data-product-type="${productType}"
      >
        <div class="cartx-add-to-cart">
          <span>Add to Cart</span>
        </div>
        <div class="cartx-atc-loading" style="display:none;">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path>
          </svg>
        </div>
      </div>
    ` : ''}
  </div>
`;

          container.appendChild(upsellDiv);
        });
      } else {
        console.warn("No upsell products found or unexpected data format.");
        if (upsellWrap) upsellWrap.style.display = "none";
      }
      
      loadedEvents();
    })
    .catch((error) => {
      console.error("Error fetching upsell products:", error);
      if (upsellWrap) upsellWrap.style.display = "none";
    });
}

// function triggerUpsellEvent() {
//   document.querySelectorAll(".cartx-upsell-add-to-cart").forEach((button) => {
//     button.addEventListener("click", (event) => {
//       event.preventDefault();
//       const variantId = button.getAttribute("data-variant-id");
//       if (!variantId) return;

//       const variantObject = {
//         [variantId]: {
//           quantity: parseInt(button.getAttribute("data-quantity")) || 0,
//           price: parseInt(button.getAttribute("data-price")) || 0,
//           type: button.getAttribute("data-product-type") || "",
//         },
//       };

//       cartx(variantObject, "ADD");
//     });
//   });
// }

function cartConfetti() {
  

  var animation = lottie.loadAnimation({
      container: document.getElementById('cartx-confetti'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: 'https://cdn.shopify.com/s/files/1/0633/2183/3679/files/Main_Scene.json?v=1746784652'
  });

  showMessage('Coupon Applied Successfully!', false);
  animation.goToAndStop(0, true);
  animation.play();

  animation.addEventListener('complete', function() {
      animation.destroy();
      document.getElementById('cartx-confetti').innerHTML = '';
  });
}

